<template>
  <div>
    <portlet
      :icon="'fad fa-user'"
      :title="'Persoonlijke gegevens'"
      :actionsBlock="true"
      :footer="true"
    >
      <template slot="actionsBlock">

        <export-resume-candidate
            :candidate="candidate"
            :profilePicture="profilePicture"
        />
      </template>
      <template slot="portletBody">
        <div class="row">
          <m-input
              :col="'col-lg-4'"
              :label="'Voornaam'"
              :forId="'candidate-firstname'"
              :required="'required'"
              v-model="candidate.firstName"
          >
          </m-input>
          <m-input
              :col="'col-lg-4'"
              :label="'Achternaam'"
              :forId="'candidate-lastname'"
              :required="'required'"
              v-model="candidate.lastName"
          >
          </m-input>
          <m-input
              :col="'col-8 col-lg-3'"
              :label="'Postcode'"
              :forId="'candidate-zipcode'"
              :required="'required'"
              inputType="zipCode"
              v-model="candidate.zipcode"
          >
          </m-input>
          <m-input
              :col="'col-4 col-lg-1 rm-p-l'"
              :label="'Nr.'"
              :forId="'candidate-nr'"
              :required="'required'"
              v-model="candidate.housenumber"
          >
          </m-input>
        </div>
        <div class="row">
          <m-input
              :col="'col-lg-4'"
              :label="'Straatnaam'"
              :forId="'candidate-street'"
              :required="'required'"
              v-model="candidate.street"
          >
          </m-input>
          <m-input
              :col="'col-lg-4'"
              :label="'Woonplaats'"
              :forId="'candidate-residence'"
              :required="'required'"
              v-model="candidate.residence"
          >
          </m-input>
          <m-input
              :col="'col-lg-4'"
              :label="'Telefoonnummer'"
              :forId="'candidate-telephone'"
              :required="'required|phone'"
              v-model="candidate.telephone"
          >
          </m-input>
        </div>
        <div class="row">
          <div class="form-group col-lg-4">
            <label for="candidate-email">E-mailadres</label>
            <input name="E-mailadres"
                   id="candidate-email"
                   type="text"
                   class="form-control"
                   v-validate="'required|email'"
                   v-model="candidate.email">
            <span v-if="errors.first('E-mailadres')" class="small text-danger">{{ errors.first('E-mailadres') }}</span>
          </div>
          <div class="form-group col-8 col-lg-3" :class="{'blacklisted': candidate.blacklisted}">
            <label for="candidate-birthdate">Geboortedatum</label>
            <input v-validate="'required'"
                   name="Geboortedatum"
                   id="candidate-birthdate"
                   type="date"
                   max="2999-12-30"
                   class="form-control placeholder-datel"
                   v-model="candidate.birthdate"
            >
            <span v-if="errors.first('Geboortedatum')" class="small text-danger">Geboortedatum moet in het volgende formaat zijn: dd-mm-jjjj</span>
          </div>
          <m-input-number
              :col="'col-4 col-lg-1 rm-p-l'"
              :label="'Leeftijd'"
              :forId="'candidate-age'"
              v-model.number="candidate.age"
              :readonly="true"
              :input-class="'form-control-plaintext'"
          >
          </m-input-number>
          <div class="col-lg-4">
            <label>Geslacht</label>
            <div class="form-group inline-radios gender-radio">
              <div class="custom-control custom-radio" v-for="(gender,index) in genders">
                <input :value="gender"
                       type="radio"
                       :id="gender"
                       name="gender"
                       class="custom-control-input"
                       v-validate="'required'"
                       v-model="candidate.gender"
                >
                <label class="custom-control-label" :for="gender">{{ gender }}</label>
              </div>
              <span v-if="errors.first('gender')" class="small text-danger">Dit veld is verplicht</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-4">
            <label for="candidate-bsn">BSN</label>
            <input name="BSN"
                   id="candidate-bsn"
                   type="text"
                   maxlength="9"
                   class="form-control"
                   :readonly="!Can(rights.IS_ADMIN)"
                   v-validate="Can(rights.IS_ADMIN) ? 'numeric|digits:9|bsn' : ''"
                   v-model="candidate.bsn"
                   @input="bsnEdited = true"
                   data-private>
            <span v-if="errors.firstByRule('BSN', 'bsn')" class="small text-danger">Dit BSN klopt niet (elfproef). Controleer het nummer.</span>
            <span v-else-if="errors.first('BSN')" class="small text-danger">Vul een BSN van 9 cijfers in.</span>
            <small v-else-if="candidate.bsnUpdatedBy" class="d-block text-muted">
              Laatst gewijzigd door {{ candidate.bsnUpdatedBy.name }}<template v-if="bsnUpdatedOn"> op {{ bsnUpdatedOn }}</template>
            </small>
            <a v-if="Can(rights.IS_ADMIN) && contractBsnSuggestion" href="#" class="small d-block" @click.prevent="takeBsnFromContract">
              Overnemen uit contract van {{ contractBsnSuggestion.date }}
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>Ik ben hier via</label>
            <div class="form-group inline-radios">
              <div class="custom-control custom-radio" v-for="known in knownFroms">
                <input :value="known"
                       type="radio"
                       :id="known"
                       name="known"
                       class="custom-control-input"
                       v-validate="'required'"
                       v-model="candidate.knownFrom"
                >
                <label class="custom-control-label" :for="known">{{ known }}</label>
              </div>
              <span v-if="errors.first('known')" class="small text-danger">Dit veld is verplicht</span>
            </div>
          </div>
        </div>
        <div class="row" v-if="candidate.knownFrom === 'Anders'">
          <div class="col-12">
            <v-select
                taggable
                v-model="candidate.knownFromOther"
                :options="knownFromOthers"

                class="form-group"
                :selectOnTab="true"
            ></v-select>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>Taal</label>
            <div class="form-group inline-checkboxes">
              <div class="custom-control custom-checkbox" v-for="(language, index) in languages"
                   :key="language+'-'+index">
                <input v-model="candidate.language"
                       :value="language"
                       type="checkbox"
                       :id="language"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="language">{{ language }}</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input v-model="candidate.language"
                       value="Anders"
                       type="checkbox"
                       id="language-other"
                       class="custom-control-input">
                <label class="custom-control-label" for="language-other">Anders</label>
              </div>
            </div>
          </div>
          <m-input
              v-if="candidate.language.includes('Anders')"
              :col="'col-sm-12 language-other'"
              :forId="'candidate-language-others'"
              name="language-other"
              :label="'Taal anders'"
              v-model="candidate.languageOther"
          >
          </m-input>
        </div>
        <div class="row">
          <div class="col-12">
            <label>Ik wil werken in</label>
            <div class="form-group inline-checkboxes">
              <div class="custom-control custom-checkbox"
                   v-for="(shift, index) in getStandardFormChoices('shifts')"
                   :key="'shift-'+index">
                <input v-model="candidate.shifts"
                       :value="shift"
                       type="checkbox"
                       :id="shift"
                       class="custom-control-input"
                       name="shifts"
                       v-validate="'required'"
                >
                <label class="custom-control-label" :for="shift">{{ shift }}</label>
              </div>
              <span v-if="errors.first('shifts')" class="small text-danger">Dit veld is verplicht</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>Ik heb ervaring met</label>
            <div class="form-group inline-checkboxes">
              <div class="custom-control custom-checkbox"
                   v-for="(experience,index) in getExperiences"
                   :key="'experience-'+index">
                <input v-model="candidate.experiences"
                       :value="experience.name"
                       type="checkbox"
                       :id="experience.id"
                       class="custom-control-input"
                       name="experiences-name"
                       v-validate="'required'"
                >
                <label class="custom-control-label"
                       :for="experience.id">{{ experience.name }}</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input v-model="candidate.experiences"
                       value="Anders"
                       type="checkbox"
                       id="experience-other"
                       class="custom-control-input">
                <label class="custom-control-label" for="experience-other">Anders</label>
              </div>
              <span v-if="errors.first('experiences-name')" class="small text-danger">Dit veld is verplicht</span>
            </div>
            <v-select v-if="candidate.experiences.includes('Anders')"
                      taggable
                      multiple
                      :options="getOtherExperiences"
                      label="name"
                      @option:created="addExperienceValue"
                      v-model="candidate.experienceOther"
                      class="form-group taggable-select"
                      :selectOnTab="true"
            ></v-select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col inline-checkboxes">
            <label class="d-block">Plaats kandidaat op de Blacklist</label>
            <div class="custom-control custom-checkbox" v-if="candidate.blacklisted && Can(rights.BLACKLIST_ADD)">
              <input type="checkbox"
                     id="blacklisted-checkbox"
                     class="custom-control-input"
                     :value="candidate.blacklisted"
                     v-model="candidate.blacklisted"
              >
              <label for="blacklisted-checkbox" class="custom-control-label">Blacklist</label>
            </div>
            <div class="custom-control custom-checkbox" v-else-if="!candidate.blacklisted">
              <input type="checkbox"
                     id="blacklisted-checkbox"
                     class="custom-control-input"
                     :value="candidate.blacklisted"
                     v-model="candidate.blacklisted"
              >
              <label for="blacklisted-checkbox" class="custom-control-label">Blacklist</label>
            </div>
            <p class="text-danger mb-0" v-else>
              Kandidaat staat op Blacklist.
            </p>

          </div>
        </div>
      </template>
      <template slot="portletFooter">
        <div class="col-12 text-right">
          <button @click="saveCandidate" type="submit" class="btn btn-primary">
            <i class="fal fa-save mr-2"></i> Opslaan
          </button>
        </div>
      </template>
    </portlet>

    <portlet
        :icon="'fad fa-file-certificate'"
        :title="'Ik heb de volgende certificaten in bezit'"
        :footer="true"
    >
      <template slot="portletBody">
        <div class="row m-hide-lg">
          <div class="col">
            <label>Certificaat</label>
          </div>
          <div class="col">
            <label>Behaald bij</label>
          </div>
          <div class="col">
            <label>Geldig tot</label>
          </div>
          <div class="col last-repeat-col"></div>
        </div>
        <select-certificate
            v-for="(certificate,index) in candidate.certificates"
            :key="index"
            :renderedComponent="renderedComponent"
            :certificates="getCertificates"
            :certificate="certificate"
            :certificateIndex="index"
            @certificateRemoved="removeCertificateRow($event)"
        ></select-certificate>
      </template>
      <div slot="portletFooter" class="col-12 text-right">
        <button @click="addCertificateRow()" type="submit" class="btn btn-secondary">
          <i class="fa fa-plus mr-2"></i> Toevoegen
        </button>
      </div>
    </portlet>

    <portlet
        :icon="'fad fa-user-graduate'"
        :title="'Ik heb de volgende opleidingen afgerond'"
        :footer="true"
    >
      <template slot="portletBody">
        <div class="row m-hide-lg">
          <div class="col">
            <label>Opleiding</label>
          </div>
          <div class="col">
            <label>Niveau</label>
          </div>
          <div class="col last-repeat-col"></div>
        </div>
        <select-education
            v-for="(education,index) in candidate.educations"
            :key="education+'-'+index"
            :renderedComponent="renderedComponent"
            :educations="getEducations"
            :education="education"
            :educationIndex="index"
            @educationRemoved="removeEducationRow($event)"
        ></select-education>
      </template>
      <div slot="portletFooter" class="col-12 text-right">
        <button @click="addEducationRow()" type="submit" class="btn btn-secondary">
          <i class="fa fa-plus mr-2"></i> Toevoegen
        </button>
      </div>
    </portlet>

    <portlet
        :icon="'fad fa-file-user'"
        :title="'Dit waren mijn laatste functies'"
        :footer="true"
    >
      <div slot="portletBody">
        <latest-functions
            v-for="(position,index) in candidate.positions"
            :key="position+'-'+index"
            :positionIndex="index"
            :positions="position"
            :renderedComponent="renderedComponent"
            @positionRemoved="removePositionRow($event)"
        ></latest-functions>
      </div>
      <div slot="portletFooter" class="col-12 text-right">
        <button @click="addPositionRow()" type="submit" class="btn btn-secondary">
          <i class="fa fa-plus mr-2"></i> Toevoegen
        </button>
      </div>
    </portlet>

    <portlet
        :icon="'fad fa-info-circle'"
        :title="'Overige informatie'"
        :footer="true"
    >
      <template slot="portletBody">
        <div class="row">
          <div class="col-12">
            <label>Ik ben in het bezit van</label>
            <div class="form-group inline-checkboxes">
              <div class="custom-control custom-checkbox"
                   v-for="transport in getStandardFormChoices('transports')">
                <input v-model="candidate.transports"
                       :value="transport"
                       type="checkbox"
                       :id="transport"
                       class="custom-control-input">
                <label class="custom-control-label" :for="transport">{{ transport }}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <label>Rijbewijzen</label>
            <div class="form-group inline-checkboxes">
              <div class="custom-control custom-checkbox"  :key="license"  v-for="license in getStandardFormChoices('drivingLicenses')">
                <input v-model="candidate.drivingLicenses"
                       :value="license"
                       type="checkbox"
                       :id="license"
                       class="custom-control-input">
                <label class="custom-control-label" :for="license">{{ license }}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-lg-4">
            <label for="candidate-max-travel">Maximale reisafstand (KM)</label>
            <input v-validate="'required'"
                   name="candidate-max-travel"
                   id="candidate-max-travel"
                   type="number"
                   class="form-control"
                   v-model="candidate.travelDistance">
            <span v-if="errors.first('candidate-max-travel')" class="small text-danger">Dit veld is verplicht.</span>
          </div>
          <div class="form-group col-lg-4 salary-input">
            <label for="candidate-salaryMin">Bruto salarisindicatie in euro's (per/uur)</label>
            <div class="row no-gutters">
              <div class="col-6">
                <input v-validate="'required'"
                       name="candidate-salaryMin"
                       id="candidate-salaryMin"
                       type="number"
                       class="form-control width-half"
                       v-model="candidate.salaryMin"
                       placeholder="Minimaal"
                >
                <span v-if="errors.first('candidate-salaryMin')" class="small text-danger">Dit veld is verplicht.</span>
              </div>
<!--              <div class="col-6">-->
<!--                <input v-validate="'required'"-->
<!--                       name="candidate-salaryMax"-->
<!--                       id="candidate-salaryMax"-->
<!--                       type="number"-->
<!--                       class="form-control width-half"-->
<!--                       v-model="candidate.salaryMax"-->
<!--                       placeholder="Maximaal"-->
<!--                >-->
<!--                <span v-if="errors.first('candidate-salaryMax')" class="small text-danger">Dit veld is verplicht.</span>-->
<!--              </div>-->
            </div>
          </div>
          <div class="form-group col-lg-4">
            <label for="candidate-availableDate">Beschikbaar per</label>
            <datepicker
                name="candidate-availableDate"
                :language="nl"
                id="candidate-availableDate"
                v-model="candidate.availableDate"
                :fullMonthName="true"
                format="dd-MM-yyyy"
                input-class='form-control'
                :calendar-button="true"
                :calendar-button-icon="'far fa-calendar-alt'"
                :clear-button="true"
                :clear-button-icon="'far fa-times'"
                :disabledDates="disabledDates"
                :class="{ 'is-invalid': errors.has('availableDate') }"
            >
            </datepicker>
            <input v-model="candidate.availableDate" v-show="false" v-validate="'required'"
                   name="availableDate"/>
          </div>
        </div>
      </template>
      <div slot="portletFooter" class="col-12 text-right">
        <button @click="saveCandidate" type="submit" class="btn btn-primary">
          <i class="fal fa-save mr-2"></i> Opslaan
        </button>
      </div>
    </portlet>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

import mInput from '../../forms/mInput';
import mInputNumber from '../../forms/mInputNumber';
import SelectCertificate from '../../candidate/selectCertificate';
import LatestFunctions from '../../candidate/latestPositions';
import SelectEducation from '../../candidate/selectEducation';
import {nl} from 'vuejs-datepicker/dist/locale';

import {candidateData} from '../../mixins/candidateData';
import {candidateMethods} from '../../mixins/candidateMethods';
import ExportResumeCandidate from './resume/exportResumeCandidate';
import {getPostalData} from './../../mixins/getPostalData';
import { Can } from '../../../../permission/ability';
import { RIGHTS } from '../../../views/roles/rights';
import { bsnChangeMarker, isValidBsn } from '@/utils/bsn';
import moment from 'moment';


export default {
  mixins: [candidateData, candidateMethods, getPostalData],
  props: ['candidateInfo', 'profilePicture'],
  components: {
    ExportResumeCandidate,
    mInput,
    mInputNumber,
    SelectEducation,
    SelectCertificate,
    LatestFunctions,
  },
  provide() {
    return {
      $validator: this.$validator
    };
  },
  data() {
    return {
      rights: '',
      isAdmin: false,
      bsnEdited: false,
      nl: nl,
      renderedComponent: true,
      candidate: {
        firstName: '',
        lastName: '',
        zipcode: '',
        housenumber: '',
        street: '',
        residence: '',
        telephone: '',
        email: '',
        birthdate: '',
        age: null,
        gender: '',
        knownFrom: '',
        knownFromOther: '',
        language: [],
        languageOther: '',
        shifts: [],
        experiences: [],
        experienceOther: [],
        certificates: [{
          name: null,
          achievedAt: null,
          validUntil: null
        }],
        educations: [{
          name: null,
          level: null
        }],
        positions: [{
          name: null,
          employer: null,
          startDate: null,
          endDate: null,
          activities: null,
          reasonLeft: null
        },
          {
            name: null,
            employer: null,
            startDate: null,
            endDate: null,
            activities: null,
            reasonLeft: null
          }],
        travelDistance: null,
        drivingLicenses:[],
        availableDate: null,
        transports: [],
        geoLocation: {lat: null, lng: null}
      },
      blacklistedBy: null
    };
  },
  methods: {
    Can,
    takeBsnFromContract() {
      this.$set(this.candidate, 'bsn', this.contractBsnSuggestion.bsn);
      this.bsnEdited = true;
    },
    markBsnChange() {
      // Only an edit made in this form counts, so a BSN a contract filled in meanwhile is not credited to whoever saves next.
      if (!this.bsnEdited) {
        return;
      }

      const marker = bsnChangeMarker(this.$store.getters.getUserData);
      Object.keys(marker).forEach(key => this.$set(this.candidate, key, marker[key]));
      this.bsnEdited = false;
    },
    updateBlackList() {
      let blackListRecord = _.find(this.getBlacklist, ['candidateId', this.candidate.id]);

      if(this.candidate.blacklisted && !this.candidateInfo.blacklisted) {
        this.blacklistedBy = this.$store.state.users.me.firstname + ' ' + this.$store.state.users.me.lastname;
      }

      if(this.candidate.blacklisted) {
        let blacklistData = {
          candidateId: this.candidate.id,
          firstName: this.candidate.firstName,
          lastName: this.candidate.lastName,
          birthdate: this.candidate.birthdate,
          blacklistedBy: this.blacklistedBy
        };
        if(blackListRecord) {
          blacklistData.id = blackListRecord.id;
        }
        this.$store.dispatch('blacklist/set', blacklistData);
      } else {
        if(blackListRecord) {
          this.$store.dispatch('blacklist/delete', blackListRecord.id);
        }
      }
    },
    autoFillBasedOnPostal(candidate) {
      let rege = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
      candidate = this.candidate;
      if(candidate.zipcode && candidate.housenumber) {
        if(rege.test(candidate.zipcode)) {
          this.$store.commit('setLoading', true);
          this.getPostalData(candidate.zipcode, candidate.housenumber).then(res => {
            if(res.status == 200) {
              let data = res.data;
              this.candidate.residence = data.city;
              this.candidate.street = data.street;
            }
          }).catch(e => {
            console.error(e);
            this.$store.commit('setLoading', false);

          }).finally(() => {
            this.$store.commit('setLoading', false);
          });
        }
      }
    },
    saveCandidate() {
      this.$validator.validateAll().then((result) => {
        let validationArrayChild = this.$children.map(function (child) {
          return child.$validator.validateAll();
        });
        window.Promise.all(validationArrayChild).then((v) => {
          let validCheck = _.includes(v, false)
          if(result && !validCheck) {
            this.convertTimestamps();
            this.markBsnChange();
            this.candidate.lastEditedBy = this.$store.getters.getUserData;
            this.candidate.department = this.$store.getters.getUserData.selectedDepartment;
            this.candidateCopy = this.candidate;
            this.updateBlackList();
            delete this.candidate.age;
            this.$emit('unsavedChanges', false);
            this.$store.dispatch('candidates/set', this.candidate).then(() => {
              this.$toasted.global.successRequest({
                message: 'Kandidaat aangepast'
              });
            });
          } else {
            this.$toasted.global.failedFormRequest();
          }
        }).catch((err) => {
          console.log(err);
        });
      }).catch((err) => {
        console.log(err);
        this.$toasted.global.failedFormRequest();
      });

    }
  },
  computed: {
    ...mapGetters('candidates', [
      'getCandidates',
      'getStandardFormChoices'
    ]),
    ...mapGetters('blacklist', ['getBlacklist', 'getBlackListRecord']),
    ...mapGetters('certificates',
        ['getCertificates']),
    ...mapGetters('educations',
        ['getEducations']),
    ...mapGetters('experiences', [
          'getExperiences',
          'getOtherExperiences'
        ]
    ),
    ...mapGetters('contracts', ['getcontracts']),
    contractBsnSuggestion() {
      if (this.candidate.bsn) {
        return null;
      }

      const latest = this.getcontracts
          .filter(contract => contract.candidateId === this.candidate.id && isValidBsn(contract.bsn))
          .sort((a, b) => (b.created_at || 0) - (a.created_at || 0))[0];

      return latest ? {bsn: latest.bsn, date: latest.created_at ? moment(latest.created_at).format('DD-MM-YYYY') : ''} : null;
    },
    bsnUpdatedOn() {
      return this.candidate.bsnUpdatedAt ? moment(this.candidate.bsnUpdatedAt).format('DD-MM-YYYY') : '';
    },
    getPositions() {
      return _.orderBy(
          this.candidate.positions,
          pos => new Date(pos.endDate), // convert string to Date
          ['desc'] // order descending
      );
    },
    notesList() {
      return _.sortBy(this.notes, ['dateNote']);
    }
  },
  created() {
    this.rights = RIGHTS;
    this.isAdmin = this.$store.state.users.me.admin;

    this.candidate = this.candidateInfo;
    if(!this.candidate.drivingLicenses){
      this.candidate.drivingLicenses = []
    }
    this.candidate.positions = this.getPositions;
    this.candidateCopy = JSON.parse(JSON.stringify(this.candidateInfo));
  },
  watch: {
    candidate: {
      handler: function (newV) {
        this.$emit('unsavedChanges', JSON.stringify(newV) !== JSON.stringify(this.candidateCopy));
        this.$emit('resetValue', this.candidateCopy);
      },
      deep: true
    },
    'candidate.birthdate': function (val) {
      this.candidate.age = Math.floor(moment.duration(moment().diff(val)).asYears());
    },
    'candidate.zipcode': function (val, oldV) {
      if(oldV) {
        this.autoFillBasedOnPostal(val);
      }
    },
    'candidate.housenumber': function (val, oldV) {
      if(oldV) {
        this.autoFillBasedOnPostal(val);
      }
    }
  }
};
</script>
